import { UPDATE_GEO } from 'state/actions/geo.actions';

const geo = (state = null, { type, payload }) => {
    switch (type) {
        case UPDATE_GEO:
            return state && state.id === payload.id ? state : payload;
        default:
            return state;
    }
};

export default geo;
